// export const baseUrl = "http://localhost:5700/api/";
export const baseUrl = "https://weltriohealth.com/api/";

